import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import {
  Box,
  IconButton,
  Popover,
  Typography,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const CreatedByInfoDialog = ({ data, loading }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleOpen} disabled={loading} sx={{ position: 'absolute', marginLeft: '-5px', marginTop: '-10px' }}>
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>

      {!loading && (
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Box sx={{ p: 2, minWidth: 220 }}>
          <Typography variant="body2">
            <strong>Created By :</strong>{' '} {data?.createdBy || '-'}
          </Typography>

          {data?.lastUpdate
            ? <Typography variant="body2">
              <strong>Last Update :</strong>{' '} {format(
                new Date(data?.lastUpdate),
                'yyyy-MM-dd HH:mm:ss'
              ) || '-'}
            </Typography>
            : null}

          <Typography variant="body2">
            <strong>Last Updated By :</strong>{' '}
            {data?.lastUpdatedBy || '-'}
          </Typography>
        </Box>
      </Popover>
      )}
    </>
  );
};

CreatedByInfoDialog.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool
};

export default CreatedByInfoDialog;
